import { AchFileActivityFilterModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class AchFileActivityFilter extends DomainEntity<AchFileActivityFilterModelDto> {
    public createDefault(): this {
        return new AchFileActivityFilter({
            fileArchiveId: 0,
            achFileName: '',
            achSourceList: [],
            achCompanyList: [],
            uploadDateType: '',
            uploadSpecificDate: '',
            uploadDateStart: '',
            uploadDateEnd: '',
            processedByList: [],
            processedDateType: '',
            processedSpecificDate: '',
            processedDateStart: '',
            processedDateEnd: '',
        }) as this;
    }

    public get fileArchiveId() {
        return this.dto.fileArchiveId;
    }

    public get achFileName() {
        return this.dto.achFileName;
    }

    public get achSourceList() {
        return this.dto.achSourceList;
    }

    public get achCompanyList() {
        return this.dto.achCompanyList;
    }

    public get uploadDateType() {
        return this.dto.uploadDateType;
    }

    public get uploadSpecificDate() {
        return this.dto.uploadSpecificDate;
    }

    public get uploadDateStart() {
        return this.dto.uploadDateStart;
    }

    public get uploadDateEnd() {
        return this.dto.uploadDateEnd;
    }

    public get processedByList() {
        return this.dto.processedByList;
    }

    public get processedDateType() {
        return this.dto.processedDateType;
    }

    public get processedSpecificDate() {
        return this.dto.processedSpecificDate;
    }

    public get processedDateStart() {
        return this.dto.processedDateStart;
    }

    public get processedDateEnd() {
        return this.dto.processedDateEnd;
    }
}
